/*eslint-disable react/no-set-state*/
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as formActions from '../../actions/formActions';
import BulkTransferHeading from './BulkTransferHeading';
import { searchForFormById } from '../../selectors/searchForForm';
import * as FormName from '../../constants/formNameConstants';
import '../../styles/establishment/establishmentDashboard.css';
import BulkTransferQueryForm from './BulkTransferQueryForm';
import * as errorMessages from '../../constants/errorMessages';
import BulkTransferForm from './BulkTransferForm';
import EstablishmentsTable from '../establishment/EstablishmentsTable/EstablishmentsTable';
import EstablishmentsTableMobile from '../establishment/EstablishmentsTable/EstablishmentsTableMobile';
import * as establishmentActions from '../../actions/establishmentActions';
import {ITAAlert} from '../common/ITAAlert';




class BulkTransferPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    
    this.state = {
      data: props.data,
      establishmentsToTransferMap: {},
      establishmentsToTransfer: [],
      numOfEstablishments: '0',
      queryFormIsValid: false,
      transferFormIsValid: false,
      activeFields: [],
      errors: {},
      submitAll: false,
      showTable: false,
      queriedEstablishments: [],
      user: props.user,
      transferFormSubmitted: false,
      transferSuccess: false,
      currentPage: 1,
      pageSize: 20
    };
    
    this.enteringData = this.enteringData.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.setActiveFields = this.setActiveFields.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.submitData = this.submitData.bind(this);
    this.selectAll = this.selectAll.bind(this);
    this.clickSelectEstablishment = this.clickSelectEstablishment.bind(this);
    this.selectEstablishment = this.selectEstablishment.bind(this);
    this.clearForm = this.clearForm.bind(this);
    this.queryData = this.queryData.bind(this);
    this.searchForEstablishmentById = this.searchForEstablishmentById.bind(this);
    this.changePageSize = this.changePageSize.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  
  confirmFormIsValid(data, requiredFields, activeFields, formNumber) {
    if (formNumber === 1) {
      let formIsValid = true;
      let errors = {};
      let emailExceptions = ['gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'mindpetal.com'];

      let addressFields = ['city', 'streetAddress', 'state'];
      let hasEin = data['ein'] !== '';
      let hasEstablishmentName = data['establishmentName'] !== '';
      let addressFieldCount = addressFields.reduce((count, field) => count + (data[field] !== '' ? 1 : 0), 0);

      if (
        (hasEin && hasEstablishmentName) || 
        (hasEin && addressFieldCount >= 1) || 
        (hasEstablishmentName && addressFieldCount >= 1)
      ) {
        formIsValid = true;
      } else {
        formIsValid = false;
      }

      requiredFields.forEach(questionPart => {
        let fieldName = questionPart.questionPartName;
        let label = questionPart.questionPartLabel === "State" ? "Your Location" : questionPart.questionPartLabel;
        if (!data[fieldName] && data[fieldName] !== 0) {
          formIsValid = false;
          if (activeFields.indexOf(fieldName) !== -1) {
            errors[fieldName] = label + errorMessages.ERROR_NEEDS_VALUE;
          }
        }
      });

      if (data.fromEmail || data.toEmail) {
        // email validation
        const emailRegex = new RegExp('^[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,}$', 'i');
        const email = data.fromEmail;
        const emailConfirmation = data.toEmail;
      
        if (email && email.search(emailRegex) === -1) {
          formIsValid = false;
          errors.fromEmail = errorMessages.ERROR_INVALID_EMAIL;
        }

        if (email == emailConfirmation) {
          formIsValid = false;
          errors.toEmail = errorMessages.ERROR_EMAILS_MATCHED;
        }
      
        if (emailConfirmation && emailConfirmation.search(emailRegex) === -1) {
          formIsValid = false;
          errors.toEmail = errorMessages.ERROR_INVALID_EMAIL;
        }
      
        if (email && emailConfirmation && email.search(emailRegex) !== -1 && emailConfirmation.search(emailRegex) !== -1) {
          const emailDomain = email.split('@')[1].trim();
          const emailConfirmationDomain = emailConfirmation.split('@')[1].trim();
      
          if (emailDomain !== emailConfirmationDomain && !emailExceptions.includes(emailDomain)) {
            formIsValid = false;
            errors.toEmail = errors.toEmail ? errors.toEmail + ' ' + errorMessages.ERROR_EMAIL_DOMAINS_NOT_MATCHED : errorMessages.ERROR_EMAIL_DOMAINS_NOT_MATCHED;
          }
        }
      }
    
      return { formIsValid, errors };
    }
    else if (formNumber === 2) {
      let formIsValid = true;
      let errors = {};
      if (this.state.establishmentsToTransfer.length == 0) {
        formIsValid = false;
      }

      if (data.removeCurrentUser == 'remove' && data.userRole == 'user') {
        formIsValid = false;
        errors.userRole = 'There must be at least one admin assigned to the establishment';
      }
      
      requiredFields.forEach(questionPart => {
        let fieldName = questionPart.questionPartName;
        let label = questionPart.questionPartLabel === "State" ? "Your Location" : questionPart.questionPartLabel;
        if (!data[fieldName] && data[fieldName] !== 0) {
          formIsValid = false;
          if (activeFields.indexOf(fieldName) !== -1) {
            errors[fieldName] = label + errorMessages.ERROR_NEEDS_VALUE;
          }
        }
      });
      return { formIsValid, errors };
    }
  }
  

  enteringData(event, formName) {
    event.preventDefault();
    const field = event.target.name;
    let data = this.state.data;
    data[field] = event.target.value;
    this.setActiveFields(field);
    this.setState({data: data});
    if (formName == FormName.bulkTransferQueryFormId) {
      this.setState({queryFormIsValid: this.confirmFormIsValid(this.state.data, this.props.queryFormRequiredFields, this.state.activeFields, 1).formIsValid});
      this.setState({errors: this.confirmFormIsValid(this.state.data, this.props.queryFormRequiredFields, this.state.activeFields, 1).errors});
    }
    else if (formName == FormName.bulkTransferFormId) {
      this.setState({transferFormIsValid: this.confirmFormIsValid(this.state.data, this.props.transferFormRequiredFields, this.state.activeFields, 2).formIsValid});
      this.setState({errors: this.confirmFormIsValid(this.state.data, this.props.transferFormRequiredFields, this.state.activeFields, 2).errors});
    }
  }

  handleClick(event, formName) {
    const field = event.target.name;
    let data = this.state.data;
    data[field] = event.target.value;
    this.setActiveFields(field);
    this.setState({data: data});
    if (formName == FormName.bulkTransferQueryFormId) {
      this.setState({queryFormIsValid: this.confirmFormIsValid(this.state.data, this.props.queryFormRequiredFields, this.state.activeFields, 1).formIsValid});
      this.setState({errors: this.confirmFormIsValid(this.state.data, this.props.queryFormRequiredFields, this.state.activeFields, 1).errors});
    }
    else if (formName == FormName.bulkTransferFormId) {
      this.setState({transferFormIsValid: this.confirmFormIsValid(this.state.data, this.props.transferFormRequiredFields, this.state.activeFields, 2).formIsValid});
      this.setState({errors: this.confirmFormIsValid(this.state.data, this.props.transferFormRequiredFields, this.state.activeFields, 2).errors});
    }
  }

  handleOnBlur(event, formName) {
    event.preventDefault();
    const field = event.target.name;
    this.setActiveFields(field);
    if (formName == FormName.bulkTransferQueryFormId) {
      this.setState({queryFormIsValid: this.confirmFormIsValid(this.state.data, this.props.queryFormRequiredFields, this.state.activeFields, 1).formIsValid});
      this.setState({errors: this.confirmFormIsValid(this.state.data, this.props.queryFormRequiredFields, this.state.activeFields, 1).errors});
    }
    else if (formName == FormName.bulkTransferFormId) {
      this.setState({transferFormIsValid: this.confirmFormIsValid(this.state.data, this.props.transferFormRequiredFields, this.state.activeFields, 2).formIsValid});
      this.setState({errors: this.confirmFormIsValid(this.state.data, this.props.transferFormRequiredFields, this.state.activeFields, 2).errors});
    }
  }

  setActiveFields(field) {
    let activeFields = this.state.activeFields;
    if (activeFields.indexOf(field) == -1) {
      activeFields.push(field);
      this.setState({activeFields: activeFields});
    }
  }

  submitData(event, data) {
    event.preventDefault();
    const establishmentIds = this.state.establishmentsToTransfer.map(establishment => establishment.id);
    const allowedKeys = ['fromEmail', 'toEmail', 'userRole', 'removeCurrentUser'];
    let filteredData = Object.keys(data).reduce((acc, key) => {
      if (allowedKeys.includes(key)) {
        acc[key] = data[key];
      }
      return acc;
    }, {});
  
    // Convert removeCurrentUser to boolean
    filteredData.removeCurrentUser = data.removeCurrentUser === 'remove';
  
    // Convert userRole to isAdmin boolean
    filteredData.isAdmin = data.userRole === 'admin';
    delete filteredData.userRole; // Remove the old userRole property
  
    filteredData.establishmentIds = establishmentIds;
  
    this.props.establishmentActions.transferEstablishments(filteredData).then((response) => {
      if (response.success) {
        this.clearForm();
        this.setState({ showTable: false, transferFormSubmitted: true, transferSuccess: true }, () => {
          window.scrollTo(0, 0);
        });
      } else {
        window.scrollTo(0, 0);
        this.clearForm();
      }
    }).catch(error => {
      throw (error);
    }) 
  }

  

  queryData(event) {
    event.preventDefault();
    const data = this.state.data;

    // Trim whitespace from all data fields
    const trimmedData = Object.keys(data).reduce((acc, key) => {
        acc[key] = typeof data[key] === 'string' ? data[key].trim() : data[key];
        return acc;
    }, {});

    const allowedKeys = ['fromEmail', 'toEmail', 'city', 'streetAddress', 'state', 'establishmentName', 'ein'];
    let filteredData = Object.keys(trimmedData).reduce((acc, key) => {
        if (allowedKeys.includes(key)) {
            acc[key] = trimmedData[key];
        }
        return acc;
    }, {});

    this.props.establishmentActions.queryEstablishmentsWithValidation(filteredData).then((response) => {
        if (response.success) {
            this.setState({queriedEstablishments: response.results });
            this.setState({showTable: true, transferFormSubmitted: false, transferSuccess: false, queryError: false, currentPage: 1 });
        } else { 
            this.setState({ transferFormSubmitted: false, transferSuccess: false }, () => {
              window.scrollTo(0, 0);
            });
            this.clearForm();
        }
    }).catch(error => {
        this.setState({ transferFormSubmitted: false, transferSuccess: false }, () => {
          window.scrollTo(0, 0);
        });
        this.clearForm();
        throw (error);
    });
};



  componentDidMount() {
    this.props.actions.retrieveAllForms(); // Fetch forms when the component mounts
  }

  componentWillUpdate() {
  }

  clearForm() {
    this.setState({
      data: this.props.data,
      establishmentsToTransferMap: {},
      establishmentsToTransfer: [],
      numOfEstablishments: '0',
      queryFormIsValid: false,
      transferFormIsValid: false,
      activeFields: [],
      errors: {},
      submitAll: false,
      showTable: false,
      queriedEstablishments: [],
      user: this.props.user,
    });
  }

  selectAll() {
    let submitAll = this.state.submitAll;
    let establishmentsToTransfer = [];
    let establishmentsToTransferMap = {};
  
    if (!submitAll) {
      this.state.queriedEstablishments.slice(0, 500).forEach(establishment => {
          establishmentsToTransferMap[establishment.id] = establishment;
          establishmentsToTransfer.push(establishment);
      });
    }
  
    this.setState({
      submitAll: !submitAll,
      establishmentsToTransfer: submitAll ? [] : establishmentsToTransfer,
      establishmentsToTransferMap: submitAll ? {} : establishmentsToTransferMap,
      numOfEstablishments: submitAll ? 0 : establishmentsToTransfer.length,
      transferFormIsValid: this.confirmFormIsValid(this.state.data, this.props.transferFormRequiredFields, this.state.activeFields, 2).formIsValid,
      errors: this.confirmFormIsValid(this.state.data, this.props.transferFormRequiredFields, this.state.activeFields, 2).errors
    });
  }
  
  clickSelectEstablishment(event) {
    const id = event.target.value;
    this.selectEstablishment(id);
  }
  
  selectEstablishment(id) {
    let establishmentsToTransferMap = this.state.establishmentsToTransferMap;
    let establishmentsToTransfer = this.state.establishmentsToTransfer;
    
    if (!establishmentsToTransferMap[id]) {
      if (establishmentsToTransfer.length >= 500) {
        console.warn("Cannot select more than 500 establishments");
        return;
      }
      const establishment = this.searchForEstablishmentById(this.state.queriedEstablishments, id);
      establishmentsToTransferMap[id] = establishment;
      establishmentsToTransfer.push(establishment);
    } else {
      delete establishmentsToTransferMap[id];
      establishmentsToTransfer = [...establishmentsToTransfer.filter(establishment => establishment.id != id)];
        }
    
    this.setState({
      establishmentsToTransferMap: establishmentsToTransferMap,
      establishmentsToTransfer: establishmentsToTransfer,
      numOfEstablishments: establishmentsToTransfer.length,
      transferFormIsValid: this.confirmFormIsValid(this.state.data, this.props.transferFormRequiredFields, this.state.activeFields, 2).formIsValid,
      errors: this.confirmFormIsValid(this.state.data, this.props.transferFormRequiredFields, this.state.activeFields, 2).errors
    });
  }

  searchForEstablishmentById(establishments, id) {
    if (establishments && establishments.length > 0) {
      const establishment = establishments.filter(establishment => {
        return establishment.id == id;
      });
      if (establishment) {
        return establishment[0];
      }
    }
    return null;
  }

  getPage(establishments) {
    let start = this.state.pageSize * (this.state.currentPage - 1);
    let end = start + this.state.pageSize;
    let numPages = this.getNumPages(establishments);
    let establishmentsNum = establishments.length;
    establishments = establishments.slice(start, end);

    let estabLength = establishments.length;
    let currentEstablishmentsNum;
    if (estabLength == 1) {
      currentEstablishmentsNum = (start + 1);
    } else {
      currentEstablishmentsNum = (start + 1) + " - " + (start + estabLength);
    }

    return {
      currentPage: this.state.currentPage,
      currentEstablishmentsNum,
      establishments,
      establishmentsNum,
      numPages,
      handlePagerClick: function (pageNum) {
        return function () {
          window.scrollBy(0, this.refs["submitMobileAnchor"].getBoundingClientRect().top);
          this.handlePageChange(pageNum);
        }.bind(this);
      }.bind(this)
    };
  }

  getNumPages(establishments) {
    let numPages = Math.floor(establishments.length / this.state.pageSize);
    if (establishments.length % this.state.pageSize > 0) {
      numPages++;
    }
    return numPages;
  }

  changePageSize(event) {
    event.preventDefault();
    this.setState({
      pageSize: parseInt(event.target.value)
    });
    this.setState({currentPage: 1});
    window.scrollBy(0, this.refs["submitMobileAnchor"].getBoundingClientRect().top);
  }

  pager(page) {
    return (
      <div className="pager">
        <div className="establishment-number col-sm-4 col-xs-6 text-left-md">
          Results {page.currentEstablishmentsNum} of {page.establishmentsNum}
        </div>
        <div className="page-size-selector col-sm-4 col-xs-6 text-right-md pull-right">
          <select className="" onChange={this.changePageSize}>
            <option value={20}>Show 20 per page</option>
            <option value={50}>Show 50 per page</option>
            <option value={100}>Show 100 per page</option>
            <option value={250}>Show 250 per page</option>
          </select>

        </div>
        <div className="pager-buttons col-sm-4 col-xs-12">
          <button
            className={"pageLink first " + ((page.currentPage <= 2) ? "disabled" : "")}
            onClick={page.handlePagerClick(1)}
            disabled={page.currentPage <= 2}>«
          </button>
          <button
            className={"pageLink previous " + ((page.currentPage == 1) ? "disabled" : "")}
            onClick={page.handlePagerClick(page.currentPage - 1)}
            disabled={page.currentPage == 1}>‹
          </button>
          <span className="currentPage">Page {page.currentPage} of {page.numPages}</span>
          <button
            className={"pageLink next " + ((page.currentPage > (page.numPages - 1))
            ? "disabled" : "")}
            onClick={page.handlePagerClick(page.currentPage + 1)}
            disabled={page.currentPage > (page.numPages - 1)}>›
          </button>
          <button
            className={"pageLink last " + ((page.currentPage >= (page.numPages - 1))
            ? "disabled" : "")}
            onClick={page.handlePagerClick(page.numPages)}
            disabled={page.currentPage >= (page.numPages - 1)}>»
          </button>
        </div>

      </div>
    );
  }

  handlePageChange(pageNum) {
    this.setState({currentPage: pageNum});
  }

  
  render() {
    let page;
    if (this.state.queriedEstablishments.length > 0 && this.state.showTable == true) {
      page = this.getPage(this.state.queriedEstablishments);
    }
    return(
      <div style={{display: 'flex', flexDirection: 'column'}} ref='submitMobileAnchor'>
        { this.state.transferFormSubmitted && this.state.transferSuccess &&
          <ITAAlert style="success"
          message={
            <div className="first-line">
              Your establishments were successfully transferred.
            </div>
          }/>}
        <BulkTransferHeading/>
        <BulkTransferQueryForm 
          form={this.props.bulkTransferQueryForm}
          onSubmit={this.queryData}
          onChange={(event) => this.enteringData(event, FormName.bulkTransferQueryFormId)}
          onClick={(event) => this.handleClick(event, FormName.bulkTransferQueryFormId)}
          onBlur={(event) => this.handleOnBlur(event, FormName.bulkTransferQueryFormId)}
          errors={this.state.errors}
          data={this.state.data}
          formIsValid={this.state.queryFormIsValid}
          user={this.state.user}/>
        { this.state.showTable === true ? 
        <div>
        <EstablishmentsTable
          establishments={page.establishments}
          onSelect={this.clickSelectEstablishment}
          onSelectAll={this.selectAll}
          selectAllChecked={this.state.submitAll}
          selectedEstablishments={this.state.establishmentsToTransferMap}
          hideStatus={true}/> 
        <EstablishmentsTableMobile
              establishments={page.establishments}
              onSelect={this.clickSelectEstablishment}
              onSelectAll={this.selectAll}
              selectAllChecked={this.state.submitAll}
              selectedEstablishments={this.state.establishmentsToTransferMap}
              hideStatus={true}/> {this.pager(page)} </div> : null}
        {this.state.showTable === true ? 
        <BulkTransferForm
          form={this.props.bulkTransferForm}
          onSubmit={this.submitData}
          onChange={(event) => this.enteringData(event, FormName.bulkTransferFormId)}
          onClick={(event) => this.handleClick(event, FormName.bulkTransferFormId)}
          onBlur={(event) => this.handleOnBlur(event, FormName.bulkTransferFormId)}
          errors={this.state.errors}
          data={this.state.data}
          formIsValid={this.state.transferFormIsValid}
          onCancel={this.clearForm}/> : null}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BulkTransferPage);


function mapStateToProps(state) {
  let bulkTransferForm = {};
  let queryFormRequiredFields = [];
  let transferFormRequiredFields = [];
  let bulkTransferQueryForm = {};
  let user = state.user.slice(-1)[0] || {};
  let data = {};
  data.fromEmail = '';
  data.toEmail = user.email || '';
  data.city = '';
  data.streetAddress = ''; 
  data.state = '';
  data.ein = '';
  data.establishmentName = '';
  data.userRole = '';
  data.removeCurrentUser = '';
  if (state.forms.length > 0) {
    bulkTransferForm = searchForFormById(state.forms, FormName.bulkTransferFormId);
    bulkTransferQueryForm = searchForFormById(state.forms, FormName.bulkTransferQueryFormId);
  }

  if (bulkTransferForm && bulkTransferForm.formQuestions) {
    transferFormRequiredFields = [].concat.apply([], bulkTransferForm.formQuestions.map(question => {
      return question.questionParts.map(questionPart => {
        return questionPart;
      }).filter(questionPart => {
        return questionPart && questionPart.questionPartRequired == 1;
      });
    }));
  }

  if (bulkTransferQueryForm && bulkTransferQueryForm.formQuestions) {
    queryFormRequiredFields = [].concat.apply([], bulkTransferQueryForm.formQuestions.map(question => {
      return question.questionParts.map(questionPart => {
        return questionPart;
      }).filter(questionPart => {
        return questionPart && (questionPart.questionPartName == 'fromEmail' || questionPart.questionPartName == 'toEmail');
      });
    }));
  }
  return {
    bulkTransferForm,
    bulkTransferQueryForm,
    transferFormRequiredFields,
    queryFormRequiredFields,
    data,
    user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(formActions, dispatch),
    establishmentActions: bindActionCreators(establishmentActions, dispatch)
  };
}


/** WEBPACK FOOTER **
 ** ./src/components/bulkTransfer/BulkTransferPage.js
 **/